

class GetNotificheModel {
    constructor(json) {
        this.messaggio = json.messaggio;
        this.id = json.id;
        this.tipo = json.tipo;
        this.id_sensore = json.id_sensore;
        this.residente = json.residente;
        this.id_stanza = json.id_stanza;
        this.creato = json.creato;
        this.timestamp = json.timestamp;
        this.confermata = json.confermata;
        this.lingua = json.lingua;
        this.nomeutente = json.nomeutente;
        this.note = json.note;
        this.id_residente = json.id_residente;
    }

}

class PutNoteNotifica {
    constructor(nota) {
        this.nota = nota;
    }
}


export { GetNotificheModel, PutNoteNotifica };
